import { render } from "./box-total-entrance.vue?vue&type=template&id=3a8a145e"
import script from "./box-total-entrance.vue?vue&type=script&lang=js"
export * from "./box-total-entrance.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__